/**
 * Login Page Animation Configurations
 * 
 * Framer Motion variants for smooth page transitions and element animations.
 * Centralized here for:
 * - Consistency across components
 * - Easy maintenance and updates
 * - Reusability
 */

import { Variants } from 'framer-motion';

/** Main page fade-in animation */
export const pageVariants: Variants = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: { duration: 0.8, ease: 'easeOut' },
    },
};

/** Login card scale + fade animation */
export const cardVariants: Variants = {
    initial: { opacity: 0, scale: 0.95, y: 20 },
    animate: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: { duration: 0.6, delay: 0.3, ease: 'easeOut' },
    },
};

/** Logo drop-in animation */
export const logoVariants: Variants = {
    initial: { opacity: 0, y: -20 },
    animate: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.5, delay: 0.5, ease: 'easeOut' },
    },
};

/** Tagline slide-up animation */
export const taglineVariants: Variants = {
    initial: { opacity: 0, y: 30 },
    animate: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, delay: 0.8 },
    },
};

/** Footer fade-in animation */
export const footerVariants: Variants = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: { delay: 1 },
    },
};

